module.exports = __webpack_public_path__ + "static/media/home_tunnel_3.d03d1a88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_tunnel_3.png
// module id = 114
// module chunks = 0